import { Link } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { Reveal } from "./motion";
import { MONTH_PAGES } from "../data/months";

// Landing-page strip routing visitors into the current month's guide.
export const MonthTeaser = () => {
  const m = MONTH_PAGES[new Date().getMonth()];
  return (
    <section data-testid="month-teaser" className="bg-white border-t border-dotted border-zinc-300">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10 md:py-14 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <Reveal>
          <p className="font-body font-800 text-xs tracking-[0.3em] eyebrow text-[#DF3226] mb-2">
            COMING IN {m.name.toUpperCase()}?
          </p>
          <h2 className="font-display font-900 tracking-tighter leading-[0.95] text-2xl sm:text-3xl">
            Copenhagen in {m.name} — {m.kicker.toLowerCase()}
            <span className="">.</span>
          </h2>
          <p className="font-body text-sm md:text-base text-black/60 mt-2 max-w-xl">
            What&apos;s on, what to pack and the honest verdict — the full {m.name} guide.
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <Link
            to={`/copenhagen-in/${m.slug}`}
            data-testid="month-teaser-link"
            className="inline-flex items-center gap-2 font-display font-900 text-base bg-black text-white px-6 py-3.5 rounded-full shadow-brut hover:-translate-y-0.5 hover:shadow-xl transition-all shrink-0"
          >
            The {m.name} guide
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
